import { Controller } from "@hotwired/stimulus";

// Clamps long text to a few lines and only offers "Show full text" when the clamp
// actually hides something. The text may connect inside a closed <details> with no
// layout yet, so measure whenever it is (re)sized instead of once on connect.
export default class extends Controller {
  static targets = ["text", "toggle"];
  static classes = ["clamp"];

  connect() {
    this.expanded = false;
    if ("ResizeObserver" in window) {
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.textTarget);
    } else {
      this.measure();
    }
  }

  disconnect() {
    this.observer?.disconnect();
  }

  measure() {
    if (this.expanded || !this.textTarget.clientHeight) return;
    const clipped = this.textTarget.scrollHeight > this.textTarget.clientHeight + 1;
    this.toggleTarget.hidden = !clipped;
  }

  toggle() {
    this.expanded = !this.expanded;
    this.textTarget.classList.toggle(this.clampClass, !this.expanded);
    this.toggleTarget.textContent = this.expanded ? "Show less" : "Show full text";
  }
}
